import { useDocumentData, useDocumentDataOnce, useLoadingValues } from "astrid-firestore/src/hooks";

import LoadingContext from "../../../ui/components/LoadingContext/LoadingContext";

import OfferContent from "../../../offers/views/OfferView/components/OfferContent";

export default function MyProductionsOfferView({ offer: staticOffer }) {
	const [[offer, production], loading, error] = useLoadingValues(
		useDocumentData(staticOffer.ref),
		useDocumentDataOnce(staticOffer.production.ref),
	);

	const [work, , workError] = useDocumentDataOnce(production?.work?.ref);

	const workLoading = !!production?.work?.ref && work === undefined && !workError;

	return (
		<>
			<LoadingContext data={production} loading={loading || workLoading} error={error}>
				{offer && <OfferContent offer={offer} production={production} work={work} />}
			</LoadingContext>
		</>
	);
}
